import i18next, { type TOptions } from 'i18next';
import { defaultUserLang } from './defaultUserLang';

export const initI18n = (resources: { [key: string]: string }, lng: string = defaultUserLang): Promise<void> => {
  return new Promise<void>((resolve) =>
    i18next.init(
      {
        lng,
        keySeparator: '$',
        fallbackLng: defaultUserLang,
        interpolation: {
          escapeValue: false,
        },
        resources: {
          [lng]: {
            translation: resources,
          },
        },
      },
      resolve,
    ),
  );
};

export const t = (key: string, params?: TOptions): string => {
  return i18next.t(key, params);
};
